<script module>
  import { resolve } from '$app/paths'

  export const meta = {
    title: 'Start here',
    teaser:
      "Welcome to Pausly! We're excited to have you join our community. The first step\nto embark on this exciting journey is to create an account. It's simple and\nstraightforward.",
    sort: 0,
  }
</script>

<p>
  To create an account just <a href={resolve('/register')}
    >click here to register</a
  > and follow the prompts.
</p>
<p>
  Once you've created your account, the next step is to choose a <strong
    >username</strong
  >. Your username bears more significance than you might initially realize. Not
  only does it serve as your identity within the Pausly community, but it also
  forms an integral part of your unique Pausly URL. This URL is something you
  can share with friends, inviting them to view your profile with ease.
</p>
<p>Your chosen username is essential for two key reasons:</p>
<ol>
  <li>
    <strong>Friend Requests:</strong> It allows others to easily add you as a friend.
  </li>
  <li>
    <strong>Session Participation:</strong> It helps friends recognize you when participating
    in sessions together.
  </li>
</ol>
<p>
  Selecting the perfect username is a critical step in setting up your Pausly
  account. So, take a moment to think about it. Choose a name that represents
  you well and makes it easy for your friends to identify you.
</p>
<p>
  Welcome aboard, and we can't wait to see what username you'll come up with!
</p>
